import type { TDocument } from '../types';

// Reusable content, the mock sheet and a Change Template request are built without a title node.
const hasTitleNode = (doc: Pick<TDocument, 'isBlock' | 'mock' | 'withoutTitle'>) =>
  !doc.isBlock && !doc.mock?.isSpreadsheet && !doc.withoutTitle;

export default hasTitleNode;
